module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades\n        "), _vm._v(" "), (!_vm.loading) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.conclui()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")])], 1) : _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.limpar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome),
      expression: "entidade.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "data-vv-as": "Razão Social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Razão social')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj|min:14|max:14'),
      expression: "'required|cnpj|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "data-vv-as": "CNPJ",
      "type": "text",
      "mask": "##.###.###/####-##"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificaCNPJEntidade($event)
      }
    },
    model: {
      value: (_vm.entidade.ds_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
      },
      expression: "entidade.ds_cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ')))]) : _vm._e()], 1), _vm._v(" "), (_vm.entidadesExistentes.length > 0 && _vm._.has(_vm.entidadesExistentes[0], 'ds_nome') && !_vm._.isNull(_vm.entidadesExistentes[0].ds_nome)) ? _c('div', {
    staticClass: "col-md-offset-3 col-md-9"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" CNPJ já cadastrado no sistema.")]), _vm._v(" "), _vm._l((_vm.entidadesExistentes), function(entidade) {
    return _c('p', [_c('router-link', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          placement: 'right',
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
      }],
      attrs: {
        "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
        "to": {
          name: 'cadastro-entidade-edita',
          params: {
            id: entidade.id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("cnpj")(entidade.ds_cnpj)) + " -\n                        " + _vm._s(entidade.ds_nome) + "\n                        (" + _vm._s(entidade.ds_nome_fantasia) + ")\n                          "), _c('i', {
      staticClass: "fa fa-external-link"
    })])], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('EmailEnt')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_email),
      expression: "entidade.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "EmailEnt",
    staticClass: "form-control",
    attrs: {
      "name": "EmailEnt",
      "type": "text",
      "data-vv-as": "E-Mail",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.entidade.ds_email)
    },
    on: {
      "change": _vm.verificaEmailEntidade,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email && _vm.usuario.ds_email) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais!')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('EmailEnt')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('EmailEnt')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('emailConfirmacaoEnt')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "userEmail"
    }
  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailConfirmacaoEnt),
      expression: "emailConfirmacaoEnt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "emailConfirmacaoEnt",
    staticClass: "form-control",
    attrs: {
      "name": "emailConfirmacaoEnt",
      "data-vv-as": "Confirmar E-Mail",
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.emailConfirmacaoEnt)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailConfirmacaoEnt = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('emailConfirmacaoEnt')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emailConfirmacaoEnt')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email !== _vm.emailConfirmacaoEnt && _vm.emailConfirmacaoEnt.length > 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "possuiCebas"
    }
  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCebas),
      expression: "possuiCebas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCebas"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeCebasCmas($event)
      }]
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "possuiCmas"
    }
  }, [_vm._v("Possui CMAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCmas),
      expression: "possuiCmas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCmas"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeCebasCmas($event)
      }]
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Representante Legal:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('userName')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_nome_usuario),
      expression: "usuario.ds_nome_usuario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "userName",
      "data-vv-as": "Nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.ds_nome_usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_nome_usuario", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('userName')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('userName')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label  col-sm-4 col-md-3",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-6 col-lg-5"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf",
      "type": "text",
      "data-vv-as": "CPF",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.usuario.ds_cpf),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ds_cpf", $$v)
      },
      expression: "usuario.ds_cpf"
    }
  }), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Login')
    }
  }, [_c('label', {
    staticClass: "control-label  col-sm-4 col-md-3",
    attrs: {
      "for": "Login"
    }
  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-6 col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_login),
      expression: "usuario.ds_login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Login",
      "data-vv-as": "Login",
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.ds_login)
    },
    on: {
      "change": _vm.verificaUsuario,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_login", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Login')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Login')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label  col-sm-4 col-md-3",
    attrs: {
      "for": "Telefone"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-6 col-lg-5"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|max:11'),
      expression: "'required|min:10|max:11'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "data-vv-as": "Telefone",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.usuario.ds_telefone),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ds_telefone", $$v)
      },
      expression: "usuario.ds_telefone"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('userEmail')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "userEmail"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_email),
      expression: "usuario.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "userEmail",
    staticClass: "form-control",
    attrs: {
      "name": "userEmail",
      "data-vv-as": "E-mail",
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.usuario.ds_email)
    },
    on: {
      "change": _vm.verificaEmailUsuario,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais.')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('userEmail')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('userEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('emailConfirmacao')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "userEmail"
    }
  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailConfirmacao),
      expression: "emailConfirmacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "emailConfirmacao",
    staticClass: "form-control",
    attrs: {
      "name": "emailConfirmacao",
      "data-vv-as": "Confirmar E-Mail",
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.emailConfirmacao)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailConfirmacao = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('emailConfirmacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emailConfirmacao')))]) : _vm._e(), _vm._v(" "), (_vm.usuario.ds_email !== _vm.emailConfirmacao && _vm.emailConfirmacao.length > 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 required-field"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('documentos')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" Documentos anexos obrigatórios: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.tiposArquivos,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um perfil",
      "label": "ds_tipo",
      "track-by": "ds_tipo",
      "preselect-first": true,
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "selectedLabel": "Selecionado",
      "name": "documentos",
      "data-vv-as": "Documentos anexos obrigatórios"
    },
    on: {
      "remove": _vm.removeDocumento
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.entidade.tipoDocumentos),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "tipoDocumentos", $$v)
      },
      expression: "entidade.tipoDocumentos"
    }
  }, [_vm._v(" "), _c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('documentos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('documentos')))]) : _vm._e()])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Credenciamento da Entidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('legend', [_vm._v(" Documentos:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dbb0862!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/entidade/CredenciamentoEntidade.vue
// module id = 1940
// module chunks = 2